<app-router-link [route]="Route.PL_Account">
  <div class="inline-flex items-center gap-2">
    <span class="font-bold">Mój profil</span>
    <app-header-icon [icon]="SvgIcon.Account" />
  </div>
</app-router-link>
